import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    date: {
        month: new Date().getMonth(),
        year: new Date().getFullYear() 
    },
    order:'asc',
    status: 'idle',
    depPaxNoShows: false,       // if true we exclude dep pax no shows from count,

    seasonalVarianceFilter: false,// include manually added seasonal variances to forecast values
    
    calendarRefreshTimeStamp: null,
    calendarRefreshMonth: null,

    error: null
};

const calendarSlice = createSlice({
    name: 'date',
    initialState,
    reducers: {
        reset: (state) => {
            return {
              date: null,
              iata: null,
              order: 'asc',
              status: 'idle',
              error: null,
              calendarRefreshTimeStamp: null,
            }
        },
        setDate: (state, action) => {
            return {
              ...state,
              date: action.payload
            }
        },
        setOrder: (state, action) => {
            return {
              ...state,
              order: action.payload
            }
        }, 
        setDepPaxNoShows: (state, action) => {
            return {
              ...state,
              depPaxNoShows: action.payload
            }
        
        },
        setSeasonalVarianceFilter: (state, action) => {
            return {
              ...state,
              seasonalVarianceFilter: action.payload
            }
        
        },
        setCalendarRefresh: (state, action) => {
            console.log('setting calendar refresh...', action.payload)
            state.calendarRefreshTimeStamp = action.payload;
        },
        setCalendarRefreshMonth: (state, action) => {
            console.log('setting calendar refresh month...', action.payload)
            state.calendarRefreshMonth = action.payload;
        }
    }
});


export const selectCalendarRefreshTimeStamp = (state) => state.date.calendarRefreshTimeStamp
export const selectCalendarRefreshMonth = (state) => state.date.calendarRefreshMonth


export const { reset, setDate, setOrder, setDepPaxNoShows, setCalendarRefresh, setSeasonalVarianceFilter } = calendarSlice.actions;
export const selectDate = state => state.date.date;
export const selectDateToISO = state => {
    try {
        return new Date(state.date.date).toISOString().split('T')[0]
    } catch {
        return ''
    }
};
export const selectDepPaxNoShowsFilter = state => state.date.depPaxNoShows;
export const selectSeasonalVarianceFilter = state => state.date.seasonalVarianceFilter;

export const selectOrder = state => state.date.order;
export const selectDateStatus = state => state.date.status;
export const errorStatus = state => state.date.error;
export default calendarSlice.reducer;
